














































































































import cloneDeep from 'lodash/cloneDeep';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'

import DeliveryZoneGroupForm from './DeliveryZoneGroupForm/DeliveryZoneGroupForm.vue';
import uniq from 'lodash/uniq';
import DeliveryZoneForm from './DeliveryZoneForm/DeliveryZoneForm.vue';
import moment from 'moment';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'exportData'
    ])
  },
  components: {
    TitleBar
  }
})
export default class DeliveryZonesManager extends Vue {
  // radioButton = 1;
  // open = false

  opened: any[] = [];

  get titleStack () {
    return [
      'Доставка', 'Управление зонами'
    ]
  }

  onDetailToggle(row: any, to: string) {
    if (to == 'open') {
      this.opened = uniq([
        ...this.opened,
        row.id
      ]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.id != row.id)
      );
    }
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null
  }

  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [this.$route.query.sortField || 'name', this.$route.query.sortDirection || 'asc']
  }

  get selectedView() {
    return this.$route.query.view || 'linked'
  }

  onSort(field: string, direction: string) {
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }
  private delayFilter: any = null

  onSearch(filter: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query, ...filter
          }
        })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  // ---------------------------------------------------------------------------

  openZoneGroup(row: any) {
    this.$buefy.modal.open({
      component: DeliveryZoneGroupForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  // productArchive(row: any) {
  //   this.$store.dispatch(`${STORE_KEY}/productToArchive`, row.id)
  //     .then((result) => {
  //       this.$buefy.snackbar.open(`Продукт помечен архивным`);
  //       this.handleParamsChange();
  //     })
  //     .catch(() => {
  //       this.$buefy.snackbar.open({
  //         type: 'is-warning',
  //         message: `При сохранении возникли проблемы. Попробуйте позже.`
  //       })
  //     })
  // }

  // productUnarchive(row: any) {
  //   this.$store.dispatch(`${STORE_KEY}/productToUnarchive`, row.id)
  //     .then((result) => {
  //       this.$buefy.snackbar.open(`Продукт помечен активным`);
  //       this.handleParamsChange();
  //     })
  //     .catch(() => {
  //       this.$buefy.snackbar.open({
  //         type: 'is-warning',
  //         message: `При сохранении возникли проблемы. Попробуйте позже.`
  //       })
  //     })
  // }

  openZone(row: any, zoneGroup: any) {
    this.$buefy.modal.open({
      component: DeliveryZoneForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: zoneGroup ? {
          delivery_zone_group_id: zoneGroup.id
        } : {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  // productContainerArchive(row: any) {
  //   this.$store.dispatch(`${STORE_KEY}/productToArchive`, row.id)
  //     .then((result) => {
  //       this.$buefy.snackbar.open(`Тара помечена архивной`);
  //       this.handleParamsChange();
  //     })
  //     .catch(() => {
  //       this.$buefy.snackbar.open({
  //         type: 'is-warning',
  //         message: `При сохранении возникли проблемы. Попробуйте позже.`
  //       })
  //     })
  // }

  // productContainerUnarchive(row: any) {
  //   this.$store.dispatch(`${STORE_KEY}/productToUnarchive`, row.id)
  //     .then((result) => {
  //       this.$buefy.snackbar.open(`Тара помечена активной`);
  //       this.handleParamsChange();
  //     })
  //     .catch(() => {
  //       this.$buefy.snackbar.open({
  //         type: 'is-warning',
  //         message: `При сохранении возникли проблемы. Попробуйте позже.`
  //       })
  //     })
  // }


  // ---------------------------------------------------------------------------

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // this.checkFilterChange();
    this.handleParamsChange();
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

  public beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
